export default __webpack_public_path__ + "static/media/information--road-skating--g1.dbd17d5a.png";